module.exports = __webpack_public_path__ + "img/Doctor.4b8df3d5.png";